__turbopack_context__.v({
  "container": "PageWrapper-module__OWSkaq__container",
  "content": "PageWrapper-module__OWSkaq__content",
  "fadeIn": "PageWrapper-module__OWSkaq__fadeIn",
  "header": "PageWrapper-module__OWSkaq__header",
  "rightElement": "PageWrapper-module__OWSkaq__rightElement",
  "subtitle": "PageWrapper-module__OWSkaq__subtitle",
  "title": "PageWrapper-module__OWSkaq__title",
  "titles": "PageWrapper-module__OWSkaq__titles",
});
